var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9066 0.964802L11.1686 8.52207H17.3865C17.5605 8.52476 17.7336 8.59638 17.8577 8.73694C18.0878 8.99716 18.0636 9.39496 17.8034 9.62505L1.70556 23.8422C1.51576 24.0096 1.23495 24.0526 0.997401 23.9285C0.689726 23.7676 0.570357 23.3874 0.731207 23.0798L5.75457 13.4884H0.630041C0.517834 13.4869 0.404433 13.4571 0.301776 13.3944C0.00484458 13.2133 -0.0888602 12.8253 0.0922827 12.5284L7.50601 0.345276C7.61046 0.140259 7.82354 0 8.06914 0L15.3736 0.00179053C15.4876 0.00328264 15.6028 0.0340202 15.7067 0.0987781C16.0009 0.282607 16.0905 0.670557 15.9066 0.964802Z",
    fill: "#FF5659"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.d17ebd4947cc6980edc35e6227656e4b.svg";
export { ForwardRef as ReactComponent };